module.exports = __webpack_public_path__ + "img/12.5f3065ee.jpg";